/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Onboardingakademieabsolviertam3Inputs */

const de__field_onboardingakademieabsolviertam3 = /** @type {(inputs: _Field_Onboardingakademieabsolviertam3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding-Akademie absolviert am`)
};

/**

* @param {_Field_Onboardingakademieabsolviertam3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_onboardingakademieabsolviertam3 = /** @type {((inputs?: _Field_Onboardingakademieabsolviertam3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Onboardingakademieabsolviertam3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_onboardingakademieabsolviertam3(inputs)
});
export { _field_onboardingakademieabsolviertam3 as "_field_onboardingAkademieAbsolviertAm" }